/* eslint-disable class-methods-use-this */
import format from 'date-fns/format';

import store from '../store';
import Model from './Model';
import FrameworkCategories from '../data/FrameworkCategories';

export default class Solution extends Model {
    static get TypeMap() {
        return {
            tool: 'Service/Tool',
            nanodegree: 'Nano-Degree',
        };
    }

    static get TimeNeededMap() {
        return {
            10: 'innert 5 Minuten',
            20: 'innert wenigen Minuten',
            30: 'innert 1-2 Stunden',
            40: 'innert wenigen Stunden',
            50: 'innert 1 Tag',
            60: 'innert wenigen Tagen',
            70: 'innert 1 Woche',
            80: 'innert wenigen Wochen',
            90: 'innert 1 Monat',
            100: 'innert Monaten',
        };
    }

    // noinspection JSMethodCanBeStatic
    resource() {
        return 'solutions';
    }

    static getAdminList() {
        return Solution.get();
    }

    get hasCategories() {
        return this.frameworkCategories.length;
    }

    get isOwner() {
        const { profile } = store.state.user;

        return profile ? this.owner === `/users/${profile.id}` : false;
    }

    get isTool() {
        return this.type === 'tool';
    }

    get isNanodegree() {
        return this.type === 'nanodegree';
    }

    get screenshot() {
        return this.image ? this.image : `${this.baseURL()}/solutions/${this.id}/screenshot`;
    }

    get typeLabel() {
        return Solution.TypeMap[this.type] || 'Unbekannt';
    }

    get readableUpdatedAt() {
        return format(this.updatedAt, 'DD.MM.YYYY');
    }

    get readableWebsite() {
        return this.website.replace(/^https?:\/\/([^/]+).*$/, '$1');
    }

    get onetimeCosts() {
        if (Intl && Intl.NumberFormat) {
            return new Intl.NumberFormat('de-CH', { style: 'currency', currency: 'CHF' }).format(this.costsOneTime);
        }

        return `CHF ${this.costsOneTime}.00`;
    }

    get recurringCosts() {
        if (Intl && Intl.NumberFormat) {
            return new Intl.NumberFormat('de-CH', { style: 'currency', currency: 'CHF' }).format(this.costsRecurring);
        }

        return `CHF ${this.costsRecurring}.00`;
    }

    get timeNeededInt() {
        return parseInt(this.timeNeeded, 10);
    }

    get timeNeededLabel() {
        switch (true) {
            case this.timeNeededInt <= 10:
                return Solution.TimeNeededMap[10];

            case this.timeNeededInt <= 20:
                return Solution.TimeNeededMap[20];

            case this.timeNeededInt <= 30:
                return Solution.TimeNeededMap[30];

            case this.timeNeededInt <= 40:
                return Solution.TimeNeededMap[40];

            case this.timeNeededInt <= 50:
                return Solution.TimeNeededMap[50];

            case this.timeNeededInt <= 60:
                return Solution.TimeNeededMap[60];

            case this.timeNeededInt <= 70:
                return Solution.TimeNeededMap[70];

            case this.timeNeededInt <= 80:
                return Solution.TimeNeededMap[80];

            case this.timeNeededInt <= 90:
                return Solution.TimeNeededMap[90];

            case this.timeNeededInt <= 100:
                return Solution.TimeNeededMap[100];

            default:
                return 'Unbekannt';
        }
    }

    hasFrameworkCategory(category) {
        if (!(this.frameworkCategories instanceof Array) || !this.frameworkCategories.length) {
            return false;
        }

        return this.frameworkCategories.includes(category.resourceId);
    }

    async getFrameworkCategories() {
        return Promise.all(
            this.frameworkCategories.map(id => FrameworkCategories.findResource(id)),
        );
    }
}
